/**
 * Google Analytics' documented per-measurement opt-out: once `window['ga-disable-<measurementId>']`
 * is true, the loaded `gtag.js` stops sending anything for that measurement ID.
 *
 * Needed alongside the AnalyticsService bot gate because gtag is not only reached through registered
 * providers: the nuxt-gtag module injects and configures the tag independently of this layer, and
 * the client plugin sets GA4 User-ID and registers the GoKollab secondary stream on the tag
 * directly. The flag makes those paths inert too.
 */
export function disableGoogleAnalyticsMeasurement(
  measurementId: string | undefined | null,
  target: Record<string, unknown> | undefined
): boolean {
  const trimmed = (measurementId ?? '').trim()
  if (!trimmed || !target) return false

  target[`ga-disable-${trimmed}`] = true
  return true
}

/**
 * Opts out every configured measurement ID. The flag is per-measurement, so the primary stream's
 * flag says nothing about a second stream configured directly on the same tag (GoKollab's CP
 * stream). Returns how many were disabled.
 */
export function disableGoogleAnalyticsMeasurements(
  measurementIds: readonly (string | undefined | null)[],
  target: Record<string, unknown> | undefined
): number {
  return measurementIds.filter(measurementId => disableGoogleAnalyticsMeasurement(measurementId, target)).length
}
